"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styles_1 = require("./styles");
const DesktopLayout = ({ children, sidebar, header, footer }) => (react_1.default.createElement(styles_1.DesktopContainer, null,
    react_1.default.createElement(styles_1.DesktopMainContent, null,
        header,
        react_1.default.createElement("section", { "data-testid": "reschedule-main-content" }, children),
        footer),
    react_1.default.createElement(styles_1.SidebarContainer, null, sidebar)));
exports.default = DesktopLayout;
//# sourceMappingURL=DesktopLayout.js.map